import { render } from "./edit-company-info.vue?vue&type=template&id=0a842d0a&scoped=true"
import script from "./edit-company-info.vue?vue&type=script&lang=js"
export * from "./edit-company-info.vue?vue&type=script&lang=js"

import "./edit-company-info.vue?vue&type=style&index=0&id=0a842d0a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a842d0a"]])

export default __exports__